import { baseApi } from "./base-api"

export interface HotelRoomDetail {
  id: number
  entity_ref: string
  title: string
  description?: string
  room_sq_ft?: number
  amenities?: string[]
  layout?: Record<string, unknown>
  photo_urls?: string[]
  hotel?: { entity_ref: string; name: string }
  beds?: unknown[]
  num_rooms?: number
  num_bedrooms?: number
  num_bathrooms?: number
}

export interface GetHotelRoomArgs {
  ref: string // e.g., "rm-GP4eGL1i"
}

export const hotelRoomsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getHotelRoom: builder.query<HotelRoomDetail, GetHotelRoomArgs>({
      query: ({ ref }) => ({
        url: `/api/hotel_rooms/${ref}`,
      }),
      transformResponse: (response: { data: HotelRoomDetail }) => response.data,
      providesTags: (result, _error, { ref }) =>
        result ? [{ type: "HotelRoom", id: ref }] : [],
    }),
  }),
})

export const { useLazyGetHotelRoomQuery, useGetHotelRoomQuery } = hotelRoomsApi
